export default "__VITE_ASSET__CImfMWlw__"